import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CopyRecommendationNavigationState } from 'src/app/models/recommendation/copy-recommendation-navigation-state';
import { ReturnDashboardRecommendation } from 'src/app/models/recommendation/return-dashboard-recommendation';
import { SearchResultRecommendation } from 'src/app/models/search/search-result-recommendation';
import { GenericAddStepOneModelEnum } from 'src/app/pages/generic-add-step-one/generic-add-step-one-model-enum';

@Component({
  selector: 'app-recommendation-card',
  templateUrl: './recommendation-card.component.html',
  styleUrls: ['./recommendation-card.component.scss'],
})
export class RecommendationCardComponent implements OnInit {

  @Input() showCopyOption: boolean = true;
  @Input() showStatus: boolean = true;

  model: RecommendationCardModel;
  @Input() set recommendation(obj: SearchResultRecommendation | ReturnDashboardRecommendation) {
    this.model = {} as RecommendationCardModel;
    this.model = Object.assign(this.model, obj);
  }

  constructor(private router: Router) { }

  ngOnInit() {}

  copy() {
    this.router.navigate(['select-customer', GenericAddStepOneModelEnum.RECOMMENDATION_COPY], {
      state: <CopyRecommendationNavigationState>{
        srcRecommendationId: this.model.id
      }
    });
  }

}

interface RecommendationCardModel {
  id: number;
  description: string;
  benefits: string;
  status: string;
  numberOfItems: number;
  numberOfUnreadMessages: number;
  creationDate: string;
  modifiedDate: string;
  customerAddressId: string;
  customerAddressType: string;
  userDefinedStatusId: number;
  userDefinedStatus: string;
  customer: string;
  created: Date;
  addressId: string;
  addressType: string;
  customerAndAddressExist: boolean;
}
